import { useState, useEffect, useRef } from 'react';
import throttle from 'lodash/throttle';
function isIos() {
    if (!navigator.platform) {
        return false;
    }
    return /iPad|iPhone|iPod/.test(navigator.platform);
}
// iOS height hack because safari sucks
// this hack is absolutely terrible and brittle so if you have any better idea,
// you are welcome to replace it
export function useIosHeightHack() {
    var rootRef = useRef(null);
    var _a = useState(false), isIosHeightHackNeeded = _a[0], setIsIosHeightHackNeeded = _a[1];
    var checkIfHackIsNeeded = function (node) {
        if (!node || !isIos()) {
            return;
        }
        // if the menu's height is bigger than the screen size, despite being 100vh,
        // we add some extra padding to force it to scroll so it cant be covered
        // by the dumb toolbar
        var menuHeight = node.getBoundingClientRect().height;
        setIsIosHeightHackNeeded(menuHeight > window.innerHeight);
    };
    var setRootRef = function (node) {
        rootRef.current = node;
        checkIfHackIsNeeded(node);
    };
    useEffect(function () {
        if (!isIos()) {
            return;
        }
        var onScroll = throttle(function () {
            checkIfHackIsNeeded(rootRef.current);
        }, 500);
        window.addEventListener('scroll', onScroll, { passive: true });
        return function () { return window.removeEventListener('scroll', onScroll); };
    }, []);
    return { isIosHeightHackNeeded: isIosHeightHackNeeded, setRootRef: setRootRef };
}
//# sourceMappingURL=useIosHeightHack.js.map